import { InjectionKey } from 'vue';

const SwitcherNameKey: InjectionKey<string> = Symbol('name');
const SwitcherOnClickKey: InjectionKey<(id: string) => void> =
	Symbol('onClick');
const SwitcherIsActiveKey: InjectionKey<(id: string) => boolean> =
	Symbol('isActive');

export { SwitcherNameKey, SwitcherOnClickKey, SwitcherIsActiveKey };
